export default __webpack_public_path__ + "static/media/FLOXX_Meetings_zonder_achtergrond.7d397300.png";